module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "block_6"
  }, [_c('span', {
    attrs: {
      "id": "id_toc"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('a', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_006#id_Hlk76416756"
    }
  }, [_vm._v("Author’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('a', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_007#id_Hlk82619698"
    }
  }, [_vm._v("Part 1")]), _c('span', {
    staticClass: "text_1"
  }), _c('a', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_007#id_Toc106115855"
    }
  }, [_vm._v("The Red Sweatshirt")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('a', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_008#id_Toc106115856"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('a', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_009#id_Toc106115858"
    }
  }, [_vm._v("Chapter 2")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('a', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_010#id_Hlk82531033"
    }
  }, [_vm._v("Chapter 3")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_011#id_Toc106115862",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_012#id_Toc106115864",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_013#id_Toc106115866",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_014#id_Hlk74506049",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 2")]), _c('span', {
    staticClass: "text_1"
  }), _c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_014#id_Toc106115869",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bloody Knife")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_015#id_Toc106115870",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_016#id_Toc106115872",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_017#id_Toc106115874",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_018#id_Toc106115876",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_019#id_Toc106115878",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_020#id_Toc106115880",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_021#id_Toc106115882",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_022#id_Toc106115884",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 3")]), _c('span', {
    staticClass: "text_1"
  }), _c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_022#id_Toc106115885",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Smoking Gun")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_023#id_Toc106115886",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_024#id_Toc106115888",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_025#id_Hlk70611453",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_026#id_Hlk76417996",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_027#id_Toc106115894",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_028#id_Toc106115896",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 4")]), _c('span', {
    staticClass: "text_1"
  }), _c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_028#id_Toc106115897",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hidden Letter")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_029#id_Toc106115898",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_030#id_Toc106115900",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_031#id_Toc106115902",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_032#id_Toc106115904",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_033#id_Toc106115906",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_034#id_Toc106115908",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_035#id_Toc106115910",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_036#id_Toc106115912",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_037#id_Toc106115914",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 5")]), _c('span', {
    staticClass: "text_1"
  }), _c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_037#id_Toc106115915",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Motive-ational Card")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_038#id_Toc106115916",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_039#id_Toc106115918",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_040#id_Toc106115920",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_041#id_Toc106115922",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 30")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_042#id_Toc106115924",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 31")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_043#id_Toc106115926",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 6")]), _c('span', {
    staticClass: "text_1"
  }), _c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_043#id_Toc106115927",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Missing Witness")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_044#id_Toc106115928",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 32")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_045#id_Toc106115930",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 33")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_046#id_Toc106115932",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 34")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_047#id_Toc106115934",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 35")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_048#id_Toc106115936",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 36")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_049#id_Toc106115938",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 37")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_050#id_Toc106115940",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 38")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_051#id_Toc106115942",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 39")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_052#id_Toc106115944",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_053#id_Toc106115946",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_054#id_Toc106115947",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1",
    attrs: {
      "href": "#/index_split_055#id_Toc106115948",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Enjoy what you read?")]), _c('span', {
    staticClass: "text_1"
  }), _c('span', {
    staticClass: "calibre2",
    attrs: {
      "href": "#/index_split_055#id_Toc106115949",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "text_1"
  }, [_vm._v("Then you’ll love ")]), _c('span', {
    staticClass: "text_2"
  }, [_vm._v("A Slow Ruin")])])]), _vm._v(" "), _c('p', {
    staticClass: "block_6"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_8",
    attrs: {
      "id": "calibre_pb_6"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f616c368","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_004.vue
// module id = 69
// module chunks = 0